module.exports = __webpack_public_path__ + "static/media/banner-header.17baa63f.png";